import type { TimelineItem } from '@/types';

export const TIMELINE: TimelineItem[] = [
  {
    id:          'asterion-cnc-2023',
    dateRange:   'Juil. 2023 → Présent',
    role:        'Coordonnateur Qualité & Maintenance · Fondateur Asterion Solutions',
    company:     'CNC Tracy Inc. & Asterion Solutions Inc.',
    location:    'Sorel-Tracy / Montréal, QC',
    description: 'Inspections finales PRIE/ITP (bras Hexagon), dossiers qualité complets, coordination NDT, gestion NCR ISO 9001. Refonte du système qualité et mise en place d\'une GMAO intégrée à l\'ERP Notixia. En parallèle : fondateur et développeur principal d\'Asterion Solutions — suite SaaS B2B industrielle. Lauréat OSEntreprendre 2026.',
    tags:        ['Hexagon · CMM', 'ISO 9001', 'GMAO · Notixia', 'React 19 · IA', 'OSEntreprendre 2026'],
    isCurrent:   true,
  },
  {
    id:          'usl-2019',
    dateRange:   'Juil. 2019 → Juil. 2023',
    role:        'Chargé de Projet — Qualité',
    company:     'Usinage Saint-Laurent',
    location:    'Sorel-Tracy, QC',
    description: 'Gestion complète de projets de réhabilitation de pièces lourdes pour barrages hydroélectriques (Hydro-Québec) et aciéries (cônes crusher, mouffles, rouleaux porteurs). Inspections dimensionnelles et NDT, dossiers qualité, coordination production / clients / sous-traitants. ERP Genius.',
    tags:        ['Hydro-Québec', 'Réhabilitation pièces lourdes', 'ERP Genius', 'GD&T · NDT'],
  },
  {
    id:          'cnc-2014',
    dateRange:   '2014 → 2019',
    role:        'Chargé de Projet / Assurance Qualité',
    company:     'CNC Tracy Inc.',
    location:    'Tracy, QC',
    description: 'Projets qualité majeurs pour Andritz, GE, Voith, Toshiba. Montage et validation des dossiers qualité, inspections finales, gestion des non-conformités. Coordination usinage / clients / fournisseurs.',
    tags:        ['Andritz · GE · Voith · Toshiba', 'Inspections finales', 'NCR · ISO'],
  },
  {
    id:          'cnc-machiniste-2012',
    dateRange:   '2012 → 2014',
    role:        'Machiniste CNC',
    company:     'CNC Tracy Inc.',
    location:    'Tracy, QC',
    description: 'Usinage CNC (Mazak V655-60 / V515), inspection dimensionnelle, montage. Première immersion dans l\'univers de la précision mécanique et de l\'hydroélectricité.',
    tags:        ['Mazak V655-60', 'CNC', 'Inspection dimensionnelle'],
  },
  {
    id:          'dut-2012',
    dateRange:   '2012',
    role:        'DUT Génie Mécanique',
    company:     'Université Paul Sabatier — Toulouse III',
    location:    'Toulouse, France',
    description: 'Formation technique en génie mécanique : tolérances, procédés de fabrication, dessin industriel, mécanique des fluides. Le socle de tout ce qui a suivi.',
    tags:        ['Toulouse · France', 'Génie Mécanique', 'Équivalent DEC Technique'],
    isEducation: true,
  },
];
